const fuelForms = <NodeListOf<HTMLFormElement>>document.querySelectorAll('.fuelCalc form');

function updateFields(inputs: any, value: number, cost: number) {
  const costs = value * cost;
  inputs.costs.value = costs.toFixed(2).toString();
  inputs.perct3.value = (costs * 0.03).toFixed(2).toString();
  inputs.perct7.value = (costs * 0.07).toFixed(2).toString();
  inputs.totalSaved.value = (costs * 0.03 + costs * 0.07).toFixed(2).toString();
  inputs.totalEmission.value = ((value * Number(inputs.totalEmission.dataset.emission)) / 1000)
    .toFixed(2)
    .toString();

  return inputs;
}

fuelForms.forEach((form) => {
  const inputs = <NodeListOf<HTMLInputElement>>form.querySelectorAll('input');
  const inputObject = {
    input: undefined,
    price: undefined,
    costs: undefined,
    perct3: undefined,
    perct7: undefined,
    totalSaved: undefined,
    totalEmission: undefined,
  };

  inputs.forEach((input: HTMLInputElement) => {
    inputObject[input.name] = input;
  });

  inputObject.input.addEventListener(
    'keydown',
    () => {
      updateFields(inputObject, inputObject.input.value, inputObject.price.value);
    },
    false,
  );
});
